import { useSavedViewsContext } from "PFApp/components/filters/saved_views_context/saved_views_context";
import { SearchInput } from "PFApp/components/search_input";
import { PageTarget } from "PFTypes/saved_filters";
import React from "react";

import css from "./toolbar.module.scss";

type FiltersSearchProps = {
  termValue: string;
  onTermChange: (term: string) => void;
  viewsKey?: PageTarget | null;
  disabled: boolean;
};

export const FiltersSearch = ({
  termValue,
  onTermChange,
  viewsKey,
  disabled
}: FiltersSearchProps): JSX.Element => {
  const { setSelectedViewId } = useSavedViewsContext(viewsKey);
  const handleTermChange = (term: string) => {
    setSelectedViewId(null);
    onTermChange(term);
  };
  return (
    <div className={css.search}>
      <SearchInput
        term={termValue}
        onTermChange={handleTermChange}
        rootClassName={css.searchInput}
        disabled={disabled}
      />
    </div>
  );
};
